// MUST be first - patches React Scheduler bug
import './react-patch';

import logger from 'redux-logger'
import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux'
import ReduxThunk from 'redux-thunk'
import * as serviceWorker from './serviceWorker';
import axios from 'axios';

import App from './components/App';
import config from './config';
import reducers from './reducers';

axios.defaults.baseURL = config.baseURLApi;
axios.defaults.headers.common['Content-Type'] = "application/json";
axios.defaults.withCredentials = true; // Include cookies in requests
const token = localStorage.getItem('token');
if (token) {
    axios.defaults.headers.common['Authorization'] = "Bearer " + token;
}
const middleware = []
const enhancers = []

let composeEnhancers = compose

middleware.push(ReduxThunk)
// will remove
if (process.env.NODE_ENV === 'development') {
    // middleware.push(logger)
}
enhancers.push(applyMiddleware(...middleware))

const store = createStore(
  reducers,
  composeEnhancers(...enhancers)
);

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root')
);

// Test commend
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
